import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Alert, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Col} from "reactstrap";
import Button from "./Button";
import api from "../api";

function SurveyReport(props){
  const [reported, setReported] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);
  const [saving, setSaving] = React.useState(false);
  const [content, setContent] = React.useState('');

  const save = () => {
    setSaving(true);

    api.surveyResponse.post.report(props.surveyResponse.id, {
      content,
      page: props.page ? props.page.id : null,
    })
    .then(data => {
      setSaving(false);
      setReported(true);
      setTimeout(() => {
        setModalOpen(false);
      }, 1500)
    })
    .catch(data => {
      setSaving(false);
    })
  }

  if(!props.surveyResponse.userId || !props.survey.reportEnable){
    return null;
  }

  return <React.Fragment>
    <div className="d-flex justify-content-center">
      <div onClick={toggleModalOpen}>
        {props.children}
      </div>
    </div>
    {modalOpen && <Modal isOpen={true} zIndex={99999999} toggle={toggleModalOpen} size="lg">
      <ModalHeader tag="h2" toggle={toggleModalOpen}>Zgłoś błąd w ankiecie</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        {reported
          ? <Alert color="info">Dziękujemy za przesłane zgłoszenie.</Alert>
          : <FormGroup row>
          <Label xs={12} md={3}>Treść zgłoszenia:</Label>
          <Col xs={12} md={9}>
            <Input autoFocus type="textarea" value={content} onChange={e => setContent(e.target.value)}/>
          </Col>
        </FormGroup>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>Anuluj</Button>
        {!reported && <Button
          color="primary"
          disabled={!content}
          loading={saving}
          onClick={save}
        >Zgłoś</Button>}
      </ModalFooter>
    </Modal>}
  </React.Fragment>
}

SurveyReport.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  page: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  survey: PropTypes.shape({
    reportEnable: PropTypes.number.isRequired,
  }),
};

function mapStateToProps(state, props) {
  return {
    surveyResponse: state.surveyResponse,
    survey: state.survey,
    page: props.pageIndex in state.pages ? state.pages[props.pageIndex] : false,
  }
}

export default connect(mapStateToProps)(SurveyReport)